import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import Close from "@mui/icons-material/Close";

import type { DialogProps } from "@mui/material";

export type ConfirmDialogProps = Omit<DialogProps, "onClose"> & {
  onClose?: () => void;
  onCancel?: () => void;
  onConfirm?: () => void;
  confirmMessage?: string;
  cancelMessage?: string;
  loading?: boolean;
  blocker?: boolean;
  reverse?: boolean;
  showCloseButton?: boolean;
};

export function ConfirmDialog({
  loading,
  onConfirm,
  onClose,
  onCancel = onClose,
  title,
  children,
  cancelMessage = "ยกเลิก",
  confirmMessage = "บันทึก",
  blocker,
  reverse = false,
  showCloseButton,
  ...props
}: ConfirmDialogProps) {
  return (
    <Dialog title={title} onClose={onClose} {...props}>
      <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
        {title}
        {showCloseButton && (
          <Tooltip title="ปิด">
            <IconButton size="medium" onClick={onClose} sx={{ ml: "auto" }}>
              <Close fontSize="large" />
            </IconButton>
          </Tooltip>
        )}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        {reverse ? (
          <>
            {onConfirm && (
              <LoadingButton
                loading={loading}
                color="inherit"
                variant="contained"
                onClick={onConfirm}
              >
                {confirmMessage}
              </LoadingButton>
            )}
            {onCancel && (
              <Button color="primary" variant="contained" onClick={onCancel}>
                {cancelMessage}
              </Button>
            )}
          </>
        ) : (
          <>
            {onCancel && (
              <Button color="inherit" variant="contained" onClick={onCancel}>
                {cancelMessage}
              </Button>
            )}
            {onConfirm && (
              <LoadingButton
                loading={loading}
                color="primary"
                variant="contained"
                onClick={onConfirm}
              >
                {confirmMessage}
              </LoadingButton>
            )}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
